var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTablerSubtask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00004 7.50002H10M3.33337 4.16669H6.66671M5.00004 4.16669V13.3334C5.00004 13.5544 5.08784 13.7663 5.24412 13.9226C5.4004 14.0789 5.61236 14.1667 5.83337 14.1667H10M10 6.66669C10 6.44567 10.0878 6.23371 10.2441 6.07743C10.4004 5.92115 10.6124 5.83335 10.8334 5.83335H15.8334C16.0544 5.83335 16.2663 5.92115 16.4226 6.07743C16.5789 6.23371 16.6667 6.44567 16.6667 6.66669V8.33335C16.6667 8.55437 16.5789 8.76633 16.4226 8.92261C16.2663 9.07889 16.0544 9.16669 15.8334 9.16669H10.8334C10.6124 9.16669 10.4004 9.07889 10.2441 8.92261C10.0878 8.76633 10 8.55437 10 8.33335V6.66669ZM10 13.3334C10 13.1123 10.0878 12.9004 10.2441 12.7441C10.4004 12.5878 10.6124 12.5 10.8334 12.5H15.8334C16.0544 12.5 16.2663 12.5878 16.4226 12.7441C16.5789 12.9004 16.6667 13.1123 16.6667 13.3334V15C16.6667 15.221 16.5789 15.433 16.4226 15.5893C16.2663 15.7456 16.0544 15.8334 15.8334 15.8334H10.8334C10.6124 15.8334 10.4004 15.7456 10.2441 15.5893C10.0878 15.433 10 15.221 10 15V13.3334Z",
    stroke: "#111111",
    strokeOpacity: 0.87,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablerSubtask);
export default __webpack_public_path__ + "static/media/tabler_subtask.4c80534a31226a5ad597d4fcfe94a64e.svg";
export { ForwardRef as ReactComponent };